import Layout, { Content } from 'antd/lib/layout/layout';
import classnames from 'classnames';
import { getToken } from 'common/api';
import { getTokenLambda } from 'common/lambda';
import LoadingComponent from 'components/Loading';
import { getTokenAppSync } from 'graphql/client';
import { AppRoutes } from 'helpers/app.routes';
import { convertParamToObject } from 'helpers/params';
import { useQueryParam } from 'hooks/useQueryParam';
import i18n from 'i18n/i18n';
import { tokenSelector } from 'modules/auth/selectors';
import React, { Suspense, useEffect, useMemo } from 'react';
import { Redirect, Route, Switch, useLocation, withRouter } from 'react-router-dom';
import { publicRoutes } from 'Routes';
import { useAppSelector } from 'utils/customHooks';

function PublicLayout() {
  const token = useAppSelector(tokenSelector);
  const location = useLocation() as any;
  const { pathname } = location;
  const queryParam = useQueryParam();
  const queryObject = useMemo(() => convertParamToObject(queryParam), [queryParam]);

  const removeLastPath = (path: string) => {
    return path.split('/').slice(0, -1).join('/');
  };

  useEffect(() => {
    // 外部ファイルアップロードの場合、英語で表示する
    if (removeLastPath(AppRoutes.preAlertFileShare) === removeLastPath(pathname)) i18n.changeLanguage('en');
  }, []);

  if (token && removeLastPath(AppRoutes.preAlertFileShare) !== removeLastPath(pathname)) {
    getToken(token);
    getTokenLambda(token);
    getTokenAppSync(token);
    // ログイン成功時、ログインURLにパラメータを保持していた場合、パラメータのURLに遷移する。
    const redirectPath = queryObject?.redirectPath ? queryObject.redirectPath : '/';
    return <Redirect to={redirectPath} />;
  }

  return (
    <Layout className={classnames('public layout-public')}>
      <Content>
        <div className="container-sm">
          <Suspense fallback={<LoadingComponent />}>
            <Switch>
              {publicRoutes.map((route: any) => (
                <Route key={route.path} component={route.component} {...route} />
              ))}
            </Switch>
          </Suspense>
        </div>
      </Content>
    </Layout>
  );
}

export default React.memo(withRouter(PublicLayout));
